import { z } from "zod";

const styleSchema = z.record(z.string(), z.union([z.string(), z.number()]));

const textItemSchema = z.object({
  type: z.literal("text"),
  text: z.string().nullable(),
  style: styleSchema.optional(),
});

const userItemSchema = z.object({
  type: z.literal("user"),
  user: z.object({
    id: z.number().int().positive(),
    email: z.string().email(),
    name: z.string().nullable(),
  }),
  style: styleSchema.optional(),
});

const offerItemSchema = z.object({
  type: z.literal("offer"),
  offer: z.object({
    id: z.string().uuid(),
    title: z.string().nullable(),
  }),
  style: styleSchema.optional(),
});

const fileItemSchema = z.object({
  type: z.literal("file"),
  file_id: z.number().int().positive(),
  original_name: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  style: styleSchema.optional(),
});

const buttonItemSchema = z.object({
  type: z.literal("button"),
  button_text: z.string(),
  button_redirect_type: z.enum([
    "redirect_link",
    "calendar_link",
    "resume_link",
    "restart_application",
  ]),
  button_url: z.string().optional(),
  resume_product_type: z.number().int().optional(),
  style: styleSchema.optional(),
});

const offersItemSchema = z.object({
  type: z.literal("offers"),
  style: styleSchema.optional(),
});

export const messageItemSchema = z.union([
  textItemSchema,
  userItemSchema,
  offerItemSchema,
  fileItemSchema,
  buttonItemSchema,
  offersItemSchema,
]);

export const messageTemplateSchema = z.object({
  version: z.string(),
  items: z.array(messageItemSchema),
  context: z.literal("borrower_platform").nullable(),
  state: z.literal("dead").nullable(),
  display_mode: z.enum(["inline", "block"]).nullable(),
});

export type MessageButtonItem = z.infer<typeof buttonItemSchema>;

export type MessageItem = z.infer<typeof messageItemSchema>;
export type MessageTemplate = z.infer<typeof messageTemplateSchema>;
